import { render, staticRenderFns } from "./invoiceIV01Dr.vue?vue&type=template&id=7ddb6562"
import script from "./invoiceIV01Dr.vue?vue&type=script&lang=js"
export * from "./invoiceIV01Dr.vue?vue&type=script&lang=js"
import style0 from "./invoiceIV01Dr.vue?vue&type=style&index=0&id=7ddb6562&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports